import { Component, OnInit } from '@angular/core';
import { timer } from 'rxjs';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css'
})
export class NotFoundComponent implements OnInit {
  loading: boolean = true;


  ngOnInit(): void {
    timer(5000).subscribe(() => {
      this.loading = false;
    });
  }

  closePage(): void {
    window.close(); // Close the current tab or window
  }
}
